const DataMainProjects = [
  {
    nameProject: "Receitas da Vovó",
    gifImage: "https://docs.google.com/uc?id=1Tvu44xOi8nXVvfndFflOoHy_6QyDFbsf",
    descriptionProject: "Aplicativo de receitas de comidas e bebidas desenvolvido em grupo, na Trybe.",
    linkProject: "https://receitasdavovo-g1.surge.sh/",
  },
  {
    nameProject: "Countdown - Bitcoin",
    gifImage: "https://docs.google.com/uc?id=10EmUfAX1-CyyrbtVmfYBMCG_ebGGtxq_",
    descriptionProject: "Contador regressivo que mostra a variação do preço do Bitcoin ao final da contagem de tempo.",
    linkProject: "https://countdownbitcoin.netlify.app",
  },
  {
    nameProject: "Escolha o seu Destino!",
    gifImage: "https://docs.google.com/uc?id=1amL6Yfywd8f8_dRrZ3I523JLspwUQSAA",
    descriptionProject: "Projeto desenvolvido em grupo que utiliza a API da NASA para exibição de imagens de planetas.",
    linkProject: "https://nasa-api-project.surge.sh/",
  },
  {
    nameProject: "Trybewarts",
    gifImage: "https://docs.google.com/uc?id=197aAs77lnsKLfv9NaZI9G04BdEIVXbYc",
    descriptionProject: "Página da Trybewarts Wizarding School para que os alunos possam enviar comentários sobre a escola.",
    linkProject: "http://trybewarts-project.surge.sh/",
  },
];

export default DataMainProjects;
